import React from "react";
import * as G from "../Grid";
import * as M from "../../Modal";
import * as C from "../../../Common";
import * as S from "../../../services";
import * as R from "../../../reducers";
import { useNavigate } from "react-router-dom";
import { TABS, T, TC } from "../../../Constants";
import { CellsTypes as CT } from "../AgGridDefs";

const auto_fit_fields: (keyof Row)[] = ["redirect", "read", "image"];
type Row = ReturnType<T.API.Access.Auth.GetNotificationsRows>[number];

export const Notifications: React.FC = () => {
    const navigate = useNavigate();
    const table_ref = React.useRef<G.TableRef<Row>>(null);

    const onReadyGrid = React.useCallback<G.TableProps<Row>["onReadyGrid"]>(grid => {
        // Show loading overlay
        grid.showLoadingOverlay();
        // Fetch the rows
        S.getNotificationsRows().then(res => {
            grid.setGridOption("rowData", res.data);
            grid.hideOverlay();
        }).catch(M.Alerts.loadError);
    }, []);

    const render_redirect = React.useCallback<G.ColDefParams<Row>["render"]>(data => <div className="text-center">
        <C.Button size='sm' icon="directions" onClick={() => navigate(data.redirect)} />
    </div>, [navigate]);

    const columns = React.useMemo<G.TableProps<Row>["columns"]>(() => [
        { field: "category", headerName: TC.NOTIF_TABLE_CATEGORY },
        { field: "read", headerName: TC.NOTIF_TABLE_READ, editable: true, type: CT.TYPE_CHECKBOX },
        { field: "redirect", headerName: TC.NOTIF_TABLE_REDIRECT, type: CT.TYPE_FREE_RENDER, params: { render: render_redirect } },
        { field: "content", headerName: TC.NOTIF_TABLE_CONTENT },
        { field: "date", headerName: TC.NOTIF_TABLE_DATE, type: CT.TYPE_DATE },
        { field: "image", headerName: TC.NOTIF_TABLE_IMAGE, type: CT.TYPE_PICTURES, params: { layout: "profile" } },
    ], [render_redirect]);

    const on_inline_change = React.useCallback<G.TableProps<Row>["onValueChange"]>(params => {
        let row = params.data,
            field = params.colDef.field as keyof Row;

        if (field === "read" && !row.read) {
            R.READ_NOTIFICATION(row._id);
            params.node.updateData({ ...params.data, read: true });
        }
        else params.api.stopEditing();
    }, []);

    const check_edit_possible = React.useCallback<G.TableProps<Row>["onCellEditingStarted"]>(event => {
        // Don't allow to edit the 'Read' property once the notification is read
        if (event.data.read) event.api.stopEditing(true);
    }, []);

    return <div className="w-100">
        <G.Table<Row>
            sideBar
            ref={table_ref}
            columns={columns}
            api_provided_rows
            onReadyGrid={onReadyGrid}
            autoFit={auto_fit_fields}
            getRowId={r => r.data._id}
            columns_base="all_but_edit"
            onValueChange={on_inline_change}
            adaptableId={TABS.NOTIFICATIONS_TABLE}
            onCellEditingStarted={check_edit_possible}
        />
    </div>;
}